import Vue from 'vue';
import axios from 'axios';
import config from '../../../load-config';
import PublicForm from '../features/studio/PublicForm.vue';
import PopupForm from '../features/studio/PopupForm.vue';

config.then(values => {
  axios.defaults.baseURL = `${values.VUE_APP_API_URL}/groovemail`;
  window.config = { grooveappsurl: values.VUE_APP_FRONTEND_URL.replace(/\/groovepages\/?$/, ''), apiUrl: axios.defaults.baseURL };
  // Public entry has no authentication state, router guard, or access to the merchant editor.
  const formId = new URLSearchParams(window.location.search).get('id') || '';
  const component = new URLSearchParams(window.location.search).get('popup') === '1' ? PopupForm : PublicForm;
  new Vue({ render: h => h(component, { props: { formId } }) }).$mount('#app');
});
